import lunr from 'lunr';

let $accordion;
let $resetBtn;
let $headers;
let $catContainers;
let $input;
let $panels;
let $expandBtn;
let $collapseBtn;
let idx, key, ref, resetForm, val;
let $seriesCatArray;
let $accordionButtons;

const initializeIssueSearch = () => {

    if (issueData == null) {
        return;
    }

    ref = issueData;
    idx = lunr(function() {
        this.ref("id");
        this.field("category", { boost: 10 });
        this.field("title", { boost: 5 });
        this.field("editor");

        this.pipeline.remove(lunr.stemmer);
        this.pipeline.remove(lunr.trimmer);
        this.pipeline.remove(lunr.stopWordFilter);

        for (key in ref) {
            val = ref[key];
            this.add(val);
        }
    });

    $accordion = document.querySelector("#js-series-accordion");
    $panels = document.querySelectorAll("[id^=\"panel-id-\"]");
    $headers = document.querySelectorAll(".js-series-cat-heading");
    $catContainers = document.querySelectorAll(".js-series-cat-container");
    $input = document.querySelector("#js-series-topic");
    $resetBtn = document.getElementById("js-series-topic-reset");
    $expandBtn = document.querySelector(".js-series-list-expand");
    $collapseBtn = document.querySelector(".js-series-list-collapse");

    resetForm = function() {
        $accordion.classList.remove("js-series-filter-active");
        $collapseBtn.click();
        $catContainers.forEach(container => {
            container.classList.remove("hidden");
        });
    };

    $resetBtn.addEventListener("click", function(event) {
        event.preventDefault();
        $input.value = null;
        return resetForm();
    });

    $input.addEventListener("input", function(event) {
        let inputValue = $input.value;
        let hit;
        let hits;

        if (inputValue.length > 0) {
            $accordion.classList.add("js-series-filter-active");
        } else {
            resetForm();
            return;
        }
        /*
          to ensure that on every change in the input
          the relevant panels are set correctly,
          we have to remove the old "hit" markers.
         */
        $panels.forEach(panel => {
            panel.classList.remove("hit");
        });

        inputValue = inputValue.toLowerCase();
        hits = idx.query(function() {
            let searchTerm = inputValue + '*';
            this.term(searchTerm);
        });

        if (hits.length > 0) {
            $expandBtn.click();

            for (key in hits) {
                hit = hits[key];
                document.querySelector("#js-series-accordion #" + hit.ref).classList.add("hit");
            }
        } else {
        }
        return $catContainers.forEach((container) => {
            container.classList.remove("hidden");
            let containerHits = container.querySelector(".hit");
            if (containerHits == null) {
                container.classList.add("hidden");
            }
        });
    });
};

const initializeCollapseExpand = () => {
    $collapseBtn.classList.add("disabled");
    $accordionButtons.forEach((button) => {
        button.addEventListener("click", handleExpandCollapse);
    });

    for (var i = 0; i < $seriesCatArray.length; i++) {
        let item = $seriesCatArray[i];
        if (!item.classList.contains("hidden")) {
            $expandBtn.classList.remove("disabled");
            $collapseBtn.classList.remove("disabled");
        }
    }

    $expandBtn.addEventListener("click", function(event) {
        if (!this.classList.contains("disabled")) {
            this.classList.add("disabled");
        }
        $collapseBtn.classList.remove("disabled");
        $seriesCatArray.forEach(openItem);
    });

    $collapseBtn.addEventListener("click", function(event) {
        if (!this.classList.contains("disabled")) {
            this.classList.add("disabled");
        }
        $expandBtn.classList.remove("disabled");
        $seriesCatArray.forEach(closeItem);
    });
};

function handleExpandCollapse() {
    let openItemsCount = 0;
    for (var i = 0; i < $seriesCatArray.length; i++) {

        let item = $seriesCatArray[i];
        if (!item.classList.contains("hidden")) {
            openItemsCount++;
        }
    }
    if (openItemsCount == 0) {
        $collapseBtn.classList.add("disabled");
    }
    if (openItemsCount > 0 && openItemsCount < $seriesCatArray.length) {
        $expandBtn.classList.remove("disabled");
        $collapseBtn.classList.remove("disabled");
    } else if (openItemsCount == $seriesCatArray.length) {
        $expandBtn.classList.add("disabled");
    }

}

function openItem(item) {
    let id = item.id;
    let split = id.split("-");
    let selector = "#js-icon-" + split[2];
    let icon = document.querySelector(selector);
    if (!icon.classList.contains("rotate-180")) {
        icon.classList.add("rotate-180");
    }

    //aria expanded handling
    let buttonId = "js-accordion-button-" + split[2];
    let button = document.getElementById(buttonId);
    if (button.getAttribute("aria-expanded") == "false") {
        button.setAttribute("aria-expanded", true);
    }

    item.classList.remove("hidden");
}

function closeItem(item) {
    let id = item.id;
    let split = id.split("-");

    // icon handling
    let selector = "#js-icon-" + split[2];
    let icon = document.querySelector(selector);
    if (icon.classList.contains("rotate-180")) {
        icon.classList.remove("rotate-180");
    }

    //aria expanded handling
    let buttonId = "js-accordion-button-" + split[2];
    let button = document.getElementById(buttonId);
    if (button.getAttribute("aria-expanded") == "true") {
        button.setAttribute("aria-expanded", false);
    }

    item.classList.add("hidden");
}


document.addEventListener("DOMContentLoaded", initIssuesPage);

function initIssuesPage() {
    // console.log("------- in initIssuesPage");
    $expandBtn = document.querySelector(".js-series-list-expand");
    $collapseBtn = document.querySelector(".js-series-list-collapse");
    $seriesCatArray = document.querySelectorAll(".js-series-cat");
    $accordionButtons = document.querySelectorAll(".accordion-header");

    initializeCollapseExpand();
    initializeIssueSearch();
}
